// Generated by Melange

import * as Buhta_cabinet__Btn from "../../../html/Btn.js";
import * as Buhta_cabinet__CalendarDatePickerInput from "../../../molecules/CalendarDatePickerInput.js";
import * as Buhta_cabinet__Checkbox from "../../../html/Checkbox.js";
import * as Buhta_cabinet__Field from "../../../html/Field.js";
import * as Buhta_cabinet__PhoneField from "../../../html/PhoneField.js";
import * as Buhta_cabinet__RadioButton from "../../../html/RadioButton.js";
import * as Buhta_cabinet__Toggle from "../../../atoms/Toggle.js";
import * as Buhta_components__Text from "../../../../../../../packages/components/src/html/Text.js";
import * as Cn from "../../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as DateTime from "../../../../../../../packages/util/lib/DateTime.js";
import * as MelNumeral from "../../../../../../../packages/util/lib/MelNumeral.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function TaxPaymentsSettingsNewEmployee(Props) {
  const match = React.useState(function () {
        return "";
      });
  const setBirthday = match[1];
  const match$1 = React.useState(function () {
        return "";
      });
  const setIin = match$1[1];
  const match$2 = React.useState(function () {
        return "";
      });
  const setLastname = match$2[1];
  const match$3 = React.useState(function () {
        return "";
      });
  const setName = match$3[1];
  const match$4 = React.useState(function () {
        return "";
      });
  const setSurname = match$4[1];
  const match$5 = React.useState(function () {
        return "";
      });
  const setPosition = match$5[1];
  const match$6 = React.useState(function () {
        return "";
      });
  const setPhoneNumber = match$6[1];
  const match$7 = React.useState(function () {
        return "";
      });
  const setEmail = match$7[1];
  const match$8 = React.useState(function () {
        return "";
      });
  const setJobStartDate = match$8[1];
  const match$9 = React.useState(function () {
        return "option1";
      });
  const setEmpTypeSelectedOption = match$9[1];
  const empTypeSelectedOption = match$9[0];
  const match$10 = React.useState(function () {
        return "option1";
      });
  const setPaymentTypeOption = match$10[1];
  const paymentTypeOption = match$10[0];
  const match$11 = React.useState(function () {
        return "";
      });
  const setSalary = match$11[1];
  const salary = match$11[0];
  const match$12 = React.useState(function () {
        return false;
      });
  const setIsStandardTaxes = match$12[1];
  const isStandardTaxes = match$12[0];
  const match$13 = React.useState(function () {
        return "";
      });
  const setTaxesStartDate = match$13[1];
  const match$14 = React.useState(function () {
        return false;
      });
  const setIsBenefit = match$14[1];
  const isBenefit = match$14[0];
  const match$15 = React.useState(function () {
        return false;
      });
  const setIsRetired = match$15[1];
  const isRetired = match$15[0];
  const match$16 = React.useState(function () {
        return "";
      });
  const setRetiredStartDate = match$16[1];
  const match$17 = React.useState(function () {
        return false;
      });
  const setIsRetiredByYearsServed = match$17[1];
  const isRetiredByYearsServed = match$17[0];
  const match$18 = React.useState(function () {
        return "";
      });
  const setRetiredByYearsStartDate = match$18[1];
  const match$19 = React.useState(function () {
        return false;
      });
  const setIsDisabled = match$19[1];
  const isDisabled = match$19[0];
  const match$20 = React.useState(function () {
        return "";
      });
  const setDisabledStartDate = match$20[1];
  const match$21 = React.useState(function () {
        return "";
      });
  const setDisabledEndDate = match$21[1];
  const match$22 = React.useState(function () {
        return false;
      });
  const setIsDisabledIndefinitely = match$22[1];
  const isDisabledIndefinitely = match$22[0];
  const match$23 = React.useState(function () {
        return "";
      });
  const setBenefitStartDate = match$23[1];
  const match$24 = React.useState(function () {
        return false;
      });
  const setIsParent = match$24[1];
  const isParent = match$24[0];
  const match$25 = React.useState(function () {
        return "";
      });
  const setParentStartDate = match$25[1];
  const match$26 = React.useState(function () {
        return "";
      });
  const setChildrenQuantity = match$26[1];
  const match$27 = React.useState(function () {
        return false;
      });
  const setIsMother = match$27[1];
  const isMother = match$27[0];
  const match$28 = React.useState(function () {
        return "";
      });
  const setMotherStartDate = match$28[1];
  const match$29 = React.useState(function () {
        return false;
      });
  const setIsStudent = match$29[1];
  const isStudent = match$29[0];
  const match$30 = React.useState(function () {
        return "";
      });
  const setStudentBenefitStartDate = match$30[1];
  const match$31 = React.useState(function () {
        return "";
      });
  const setStudentBenefitEndDate = match$31[1];
  return JsxRuntime.jsxs("form", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                    label: "ИИН",
                                    type_: "text",
                                    name: "iin",
                                    size: "m",
                                    required: true,
                                    onChange: (function (value) {
                                        Curry._1(setIin, (function (param) {
                                                return value;
                                              }));
                                      }),
                                    value: match$1[0]
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                            label: "Фамилия",
                                            type_: "text",
                                            name: "lastname",
                                            size: "m",
                                            required: true,
                                            onChange: (function (value) {
                                                Curry._1(setLastname, (function (param) {
                                                        return value;
                                                      }));
                                              }),
                                            value: match$2[0]
                                          }),
                                      JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                            label: "Имя",
                                            type_: "text",
                                            name: "name",
                                            size: "m",
                                            required: true,
                                            onChange: (function (value) {
                                                Curry._1(setName, (function (param) {
                                                        return value;
                                                      }));
                                              }),
                                            value: match$3[0]
                                          }),
                                      JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                            label: "Отчество",
                                            type_: "text",
                                            name: "surname",
                                            size: "m",
                                            onChange: (function (value) {
                                                Curry._1(setSurname, (function (param) {
                                                        return value;
                                                      }));
                                              }),
                                            value: match$4[0]
                                          })
                                    ],
                                    className: "flex flex-col md:flex-row gap-4 mt-6"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                            label: "Должность",
                                            type_: "text",
                                            name: "position",
                                            size: "m",
                                            onChange: (function (value) {
                                                Curry._1(setPosition, (function (param) {
                                                        return value;
                                                      }));
                                              }),
                                            className: "mb-4",
                                            value: match$5[0]
                                          }),
                                      JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                            value: match[0],
                                            onPicked: (function (date) {
                                                Curry._1(setBirthday, (function (param) {
                                                        return DateTime.toDateFormat(date);
                                                      }));
                                              }),
                                            align: "BottomRight",
                                            className: "w-full",
                                            label: "Дата рождения"
                                          })
                                    ],
                                    className: "md:grid md:grid-cols-2 items-center gap-4 mt-4 md:mt-6"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx(Buhta_cabinet__PhoneField.make, {
                                            value: match$6[0],
                                            onChange: (function (value) {
                                                Curry._1(setPhoneNumber, (function (param) {
                                                        return value;
                                                      }));
                                              }),
                                            size: "m",
                                            className: "mb-4",
                                            label: "Номер телефона"
                                          }),
                                      JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                            label: "Почта",
                                            type_: "email",
                                            name: "email",
                                            size: "m",
                                            onChange: (function (value) {
                                                Curry._1(setEmail, (function (param) {
                                                        return value;
                                                      }));
                                              }),
                                            value: match$7[0]
                                          })
                                    ],
                                    className: "md:grid md:grid-cols-2 items-center gap-4 mt-4"
                                  }),
                              JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                    value: match$8[0],
                                    onPicked: (function (date) {
                                        Curry._1(setJobStartDate, (function (param) {
                                                return DateTime.toDateFormat(date);
                                              }));
                                      }),
                                    align: "BottomLeft",
                                    className: "mt-6 w-full",
                                    label: "Дата начала работы"
                                  }),
                              JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                    className: "text-default-gray mt-6 font-semibold",
                                    children: "ТИП СОТРУДНИКА"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                                            className: "mt-4",
                                            checked: empTypeSelectedOption === "option1",
                                            onChange: (function (param) {
                                                Curry._1(setEmpTypeSelectedOption, (function (param) {
                                                        return "option1";
                                                      }));
                                              }),
                                            children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                  className: "ml-1",
                                                  children: "Трудовой договор"
                                                })
                                          }),
                                      JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                                            className: "mt-4",
                                            checked: empTypeSelectedOption === "option2",
                                            onChange: (function (param) {
                                                Curry._1(setEmpTypeSelectedOption, (function (param) {
                                                        return "option2";
                                                      }));
                                              }),
                                            children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                  className: "ml-1",
                                                  children: "ГПХ"
                                                })
                                          })
                                    ],
                                    className: "flex gap-6"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                            className: "text-default-gray mt-6 font-semibold",
                                            children: "МЕТОД РАСЧЕТА"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                                                    className: "mt-4",
                                                    checked: paymentTypeOption === "option1",
                                                    onChange: (function (param) {
                                                        Curry._1(setPaymentTypeOption, (function (param) {
                                                                return "option1";
                                                              }));
                                                      }),
                                                    children: JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
                                                          className: "ml-1",
                                                          children: [
                                                            "От обратного",
                                                            JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                                                  className: "text-gray-medium",
                                                                  children: "Зарплата на руки"
                                                                })
                                                          ]
                                                        })
                                                  }),
                                              JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                                                    className: "mt-4",
                                                    checked: paymentTypeOption === "option2",
                                                    onChange: (function (param) {
                                                        Curry._1(setPaymentTypeOption, (function (param) {
                                                                return "option2";
                                                              }));
                                                      }),
                                                    children: JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
                                                          className: "ml-1",
                                                          children: [
                                                            "Прямой расчет",
                                                            JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                                                  className: "text-gray-medium",
                                                                  children: "Зарплата с налогами"
                                                                })
                                                          ]
                                                        })
                                                  })
                                            ],
                                            className: "flex gap-6"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                    label: "Зарплата",
                                                    name: "salary",
                                                    size: "m",
                                                    required: true,
                                                    onChange: (function (value) {
                                                        Curry._1(setSalary, (function (param) {
                                                                return value;
                                                              }));
                                                      }),
                                                    value: salary.length !== 0 ? MelNumeral.formatInt({
                                                            NAME: "Str",
                                                            VAL: salary
                                                          }) : ""
                                                  }),
                                              JsxRuntime.jsx("img", {
                                                    className: "absolute right-4 top-4 w-5 h-5",
                                                    alt: "tenge",
                                                    src: StaticAsset.src("/static/icons/tenge.svg")
                                                  })
                                            ],
                                            className: Cn.$plus("relative mt-4", Cn.on("hidden", empTypeSelectedOption === "option2"))
                                          }),
                                      JsxRuntime.jsxs(Buhta_components__Text.Caption.make, {
                                            className: Cn.$plus("text-asphalt mt-1", Cn.on("hidden", empTypeSelectedOption === "option2")),
                                            children: [
                                              "Минимальная сумма — ",
                                              JsxRuntime.jsx("span", {
                                                    children: "85 000 ₸",
                                                    className: "text-links cursor-pointer",
                                                    onClick: (function (param) {
                                                        Curry._1(setSalary, (function (param) {
                                                                return "85000";
                                                              }));
                                                      })
                                                  })
                                            ]
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                            children: "Применить стандартный налоговый вычет"
                                                          }),
                                                      JsxRuntime.jsx("img", {
                                                            className: "w-5 h-5",
                                                            alt: "info",
                                                            src: StaticAsset.src("/static/icons/info.svg")
                                                          })
                                                    ],
                                                    className: "flex gap-2 items-center"
                                                  }),
                                              JsxRuntime.jsx(Buhta_cabinet__Toggle.make, {
                                                    checked: isStandardTaxes,
                                                    onChange: (function (value) {
                                                        Curry._1(setIsStandardTaxes, (function (param) {
                                                                return value;
                                                              }));
                                                      })
                                                  })
                                            ],
                                            className: Cn.$plus("flex justify-between items-center mt-6 gap-2", Cn.on("hidden", empTypeSelectedOption === "option2"))
                                          }),
                                      JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                                  value: match$13[0],
                                                  onPicked: (function (date) {
                                                      Curry._1(setTaxesStartDate, (function (param) {
                                                              return DateTime.toDateFormat(date);
                                                            }));
                                                    }),
                                                  align: "BottomLeft",
                                                  className: "w-full",
                                                  label: "Начиная с"
                                                }),
                                            className: Cn.$plus(Cn.$plus("mt-2", Cn.on("hidden", !isStandardTaxes)), Cn.on("hidden", empTypeSelectedOption === "option2"))
                                          })
                                    ]
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                    children: "Применить льготы"
                                                  }),
                                              JsxRuntime.jsx("img", {
                                                    className: "w-5 h-5",
                                                    alt: "info",
                                                    src: StaticAsset.src("/static/icons/info.svg")
                                                  })
                                            ],
                                            className: "flex gap-2 items-center"
                                          }),
                                      JsxRuntime.jsx(Buhta_cabinet__Toggle.make, {
                                            checked: isBenefit,
                                            onChange: (function (value) {
                                                Curry._1(setIsBenefit, (function (param) {
                                                        return value;
                                                      }));
                                              })
                                          })
                                    ],
                                    className: "flex justify-between items-center mt-6"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                            isChecked: isRetired,
                                            onChange: (function (param) {
                                                Curry._1(setIsRetired, (function (param) {
                                                        return !isRetired;
                                                      }));
                                              }),
                                            text: "Пенсионер по возрасту",
                                            subText: "мужчины — 63, женщины — 61"
                                          }),
                                      JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                                  value: match$16[0],
                                                  onPicked: (function (date) {
                                                      Curry._1(setRetiredStartDate, (function (param) {
                                                              return DateTime.toDateFormat(date);
                                                            }));
                                                    }),
                                                  align: "BottomLeft",
                                                  label: "Дата начала льготы"
                                                }),
                                            className: Cn.$plus("mt-2 px-6", Cn.on("hidden", !isRetired))
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                                    isChecked: isRetiredByYearsServed,
                                                    onChange: (function (param) {
                                                        Curry._1(setIsRetiredByYearsServed, (function (param) {
                                                                return !isRetiredByYearsServed;
                                                              }));
                                                      }),
                                                    text: "Пенсионер по выслуге лет"
                                                  }),
                                              JsxRuntime.jsx("img", {
                                                    className: "w-5 h-5",
                                                    alt: "info",
                                                    src: StaticAsset.src("/static/icons/info.svg")
                                                  })
                                            ],
                                            className: "flex gap-2 items-center"
                                          }),
                                      JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                                  value: match$18[0],
                                                  onPicked: (function (date) {
                                                      Curry._1(setRetiredByYearsStartDate, (function (param) {
                                                              return DateTime.toDateFormat(date);
                                                            }));
                                                    }),
                                                  align: "BottomLeft",
                                                  label: "Дата начала льготы"
                                                }),
                                            className: Cn.$plus("mt-2 px-6", Cn.on("hidden", !isRetiredByYearsServed))
                                          }),
                                      JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                            isChecked: isDisabled,
                                            onChange: (function (param) {
                                                Curry._1(setIsDisabled, (function (param) {
                                                        return !isDisabled;
                                                      }));
                                              }),
                                            text: "Инвалид I, II, III группы"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("div", {
                                                    children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                                          value: match$20[0],
                                                          onPicked: (function (date) {
                                                              Curry._1(setDisabledStartDate, (function (param) {
                                                                      return DateTime.toDateFormat(date);
                                                                    }));
                                                            }),
                                                          align: "BottomLeft",
                                                          label: "Дата начала льготы"
                                                        }),
                                                    className: "grow"
                                                  }),
                                              JsxRuntime.jsx("div", {
                                                    children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                                          value: match$21[0],
                                                          onPicked: (function (date) {
                                                              Curry._1(setDisabledEndDate, (function (param) {
                                                                      return DateTime.toDateFormat(date);
                                                                    }));
                                                            }),
                                                          align: "BottomLeft",
                                                          label: "Дата окончания"
                                                        }),
                                                    className: "grow"
                                                  })
                                            ],
                                            className: Cn.$plus("mt-2 px-6 flex flex-col md:flex-row gap-4", Cn.on("hidden", !isDisabled))
                                          }),
                                      JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                            isChecked: isDisabledIndefinitely,
                                            onChange: (function (param) {
                                                Curry._1(setIsDisabledIndefinitely, (function (param) {
                                                        return !isDisabledIndefinitely;
                                                      }));
                                              }),
                                            text: "Инвалид I, II группы бессрочно"
                                          }),
                                      JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                                  value: match$23[0],
                                                  onPicked: (function (date) {
                                                      Curry._1(setBenefitStartDate, (function (param) {
                                                              return DateTime.toDateFormat(date);
                                                            }));
                                                    }),
                                                  align: "BottomLeft",
                                                  label: "Дата начала льготы"
                                                }),
                                            className: Cn.$plus("mt-2 px-6", Cn.on("hidden", !isDisabledIndefinitely))
                                          }),
                                      JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                            isChecked: isParent,
                                            onChange: (function (param) {
                                                Curry._1(setIsParent, (function (param) {
                                                        return !isParent;
                                                      }));
                                              }),
                                            text: "Родитель/опекун инвалида"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                                    value: match$25[0],
                                                    onPicked: (function (date) {
                                                        Curry._1(setParentStartDate, (function (param) {
                                                                return DateTime.toDateFormat(date);
                                                              }));
                                                      }),
                                                    align: "BottomLeft",
                                                    className: "md:w-[209px]",
                                                    label: "Дата начала льгот"
                                                  }),
                                              JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                                    label: "Количество детей",
                                                    type_: "text",
                                                    name: "name",
                                                    size: "m",
                                                    required: true,
                                                    onChange: (function (value) {
                                                        Curry._1(setChildrenQuantity, (function (param) {
                                                                return value;
                                                              }));
                                                      }),
                                                    className: "md:w-[209px]",
                                                    value: match$26[0]
                                                  })
                                            ],
                                            className: Cn.$plus("mt-2 px-6 flex flex-col md:flex-row gap-4", Cn.on("hidden", !isParent))
                                          }),
                                      JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                            isChecked: isMother,
                                            onChange: (function (param) {
                                                Curry._1(setIsMother, (function (param) {
                                                        return !isMother;
                                                      }));
                                              }),
                                            text: "Многодетная мать",
                                            subText: "4 и более детей"
                                          }),
                                      JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                                  value: match$28[0],
                                                  onPicked: (function (date) {
                                                      Curry._1(setMotherStartDate, (function (param) {
                                                              return DateTime.toDateFormat(date);
                                                            }));
                                                    }),
                                                  align: "BottomLeft",
                                                  label: "Дата начала льготы"
                                                }),
                                            className: Cn.$plus("mt-2 px-6", Cn.on("hidden", !isMother))
                                          }),
                                      JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                            isChecked: isStudent,
                                            onChange: (function (param) {
                                                Curry._1(setIsStudent, (function (param) {
                                                        return !isStudent;
                                                      }));
                                              }),
                                            text: "Студент"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("div", {
                                                    children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                                          value: match$30[0],
                                                          onPicked: (function (date) {
                                                              Curry._1(setStudentBenefitStartDate, (function (param) {
                                                                      return DateTime.toDateFormat(date);
                                                                    }));
                                                            }),
                                                          align: "BottomLeft",
                                                          label: "Начало обучения"
                                                        }),
                                                    className: "grow"
                                                  }),
                                              JsxRuntime.jsx("div", {
                                                    children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                                          value: match$31[0],
                                                          onPicked: (function (date) {
                                                              Curry._1(setStudentBenefitEndDate, (function (param) {
                                                                      return DateTime.toDateFormat(date);
                                                                    }));
                                                            }),
                                                          align: "BottomLeft",
                                                          label: "Дата окончания"
                                                        }),
                                                    className: "grow"
                                                  })
                                            ],
                                            className: Cn.$plus("mt-2 px-6 flex flex-col md:flex-row gap-4", Cn.on("hidden", !isStudent))
                                          })
                                    ],
                                    className: Cn.$plus("space-y-4 mt-4", Cn.on("hidden", !isBenefit))
                                  })
                            ],
                            className: "px-6 py-10 md:p-10"
                          }),
                      className: "bg-white min-w-[343px] md:w-[562px] rounded-md"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
                            title: "Добавить",
                            className: "px-6 py-3",
                            type_: "submit"
                          }),
                      className: "md:w-[562px] flex justify-end mt-6"
                    })
              ]
            });
}

const make = TaxPaymentsSettingsNewEmployee;

export {
  make ,
}
/* Buhta_cabinet__Btn Not a pure module */
